import { FeedbackCollector } from '@atlassian/mpac-ui';
import React from 'react';
import { ANALYTICS_FEEDBACK_UI_NO, ANALYTICS_FEEDBACK_UI_SUBMIT, ANALYTICS_FEEDBACK_UI_YES } from "../../analytics";
import usePrivacySecurityAnalytics from "../../hooks/usePrivacySecurityAnalytics";
export const FeedbackCollectorWrapper = _ref => {
  let {
    userId,
    feedbackGatewayBaseUrl,
    feedbackCollectorApiKeys
  } = _ref;
  const {
    fireButtonEvent
  } = usePrivacySecurityAnalytics();
  const onSubmitClick = feedbackvalues => {
    fireButtonEvent(ANALYTICS_FEEDBACK_UI_SUBMIT, {
      'Feedback type': feedbackvalues.type,
      'Feedback description': feedbackvalues.description
    });
  };
  const onYesClick = () => {
    fireButtonEvent(ANALYTICS_FEEDBACK_UI_YES);
  };
  const onNoClick = () => {
    fireButtonEvent(ANALYTICS_FEEDBACK_UI_NO);
  };
  return /*#__PURE__*/React.createElement(FeedbackCollector, {
    embeddableKey: feedbackCollectorApiKeys.privacyAndSecurity.embeddableKey,
    requestTypeId: feedbackCollectorApiKeys.privacyAndSecurity.requestTypeId,
    feedbackGatewayBaseUrl: feedbackGatewayBaseUrl,
    userId: userId,
    onSubmitClick: onSubmitClick,
    onYesClick: onYesClick,
    onNoClick: onNoClick
  });
};